///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>

///<reference path="../collections/manufacturers.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class PurchaseOrderManufacturersDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected manufacturers: ManufacturersCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.manufacturers;
        }

        get totalSelectedCount(): number {
            return this.manufacturers.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.filters = [new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_MANUFACTURERS' })];
            this.manufacturers = new ManufacturersCollection(this.model[this.properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.manufacturers.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_MANUFACTURERS';
            this.allSelectedLabel = 'LABEL_ALL_MANUFACTURERS';
            this.totalSelectedMessage = 'LABEL_TOTAL_MANUFACTURERS_SELECTED';
        }
    }
}
